<template>
  <a-modal
    title="数据导入"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button @click="handleCancel">
        关闭
      </a-button>
    </template>

    <div class="a-import">
      <a-row :gutter="16">
        <a-col :span="12">
          <span>
            <a-radio-group
              :options="importOptions"
              default-value="0"
              @change="onChangeImport($event)"
            /></span>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="6">
          点击查看模板:
        </a-col>
        <a-col :span="6">
          <a :href="selectUrl">{{ selectURLName }}</a>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="6">
          <hy-upload
            ref="fileUpload"
            :accept="'.xls,.xlsx'"
            :upload-params="{ code: 'creative-platform', app: 'op'}"
            :is-show-list="false"
            @success="successEvent"
            @uploadChange="uploadChange"
          >
            <template
              v-if="importLoading"
              slot="content"
            >
              <!-- 自定义样式 -->
              <a-button>
                <a-icon type="loading" /> 上传文件
              </a-button>
            </template>
          </hy-upload>
        </a-col>
      </a-row>
      <a
        v-if="hasUploaded"
        :href="uploadedURL"
      >{{ uploadedName }}</a>
      <div v-if="lopMessageVisible">
        上传进度：{{ lopMessage }}
      </div>

      <div v-if="!isStandard">
        <a-popconfirm
          title="资源超发，请确认信息"
          ok-text="确认"
          cancel-text="取消"
          :visible="popVisible"
          @confirm="confirmImport"
          @cancel="confirmImportCancel"
        >
          <a-table
            :columns="columns"
            :data-source="dataSource"
            :pagination="false"
            :row-key="(item, index) => index"
          />
        </a-popconfirm>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { importURL } from '@/constants/common'
import { importReleaseRecord, importRecoveryRecord, importReleaseRecordProgress, importRecoveryRecordProgress } from '@/api/flowDetail.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      columns: [
        {
          title: '行数',
          dataIndex: 'row',
          key: 'row'
        },
        {
          title: '未通过原因',
          dataIndex: 'message',
          key: 'message'
        }],
      dataSource: [],
      importURL,
      importOptions: [{ label: '资源发放', value: '0' }, { label: '资源回收', value: '1' }],
      selectURLName: '资源发放模板',
      selectUrl: importURL.ImportReleaseURL,
      selectType: '0',
      hasUploaded: false,
      uploadedName: '',
      uploadedURL: '',
      isStandard: true,
      importLoading: false,
      popVisible: false,
      msg: undefined,
      lopMessage: undefined,
      lopMessageVisible: false
    }
  },
  methods: {
    // loopResult,
    handleCancel () {
      this.$emit('importCancel')
      this.hasUploaded = false
      this.isStandard = true
      this.popVisible = false
      this.lopMessageVisible = false
      this.selectType = '0'
      this.selectUrl = importURL.ImportReleaseURL
      this.selectURLName = '资源发放模板'
    },
    onChangeImport (e) {
      this.dataSource = []
      this.hasUploaded = false
      this.isStandard = true
      this.lopMessageVisible = false
      if (e.target.value === '0') {
        this.selectUrl = importURL.ImportReleaseURL
        this.selectURLName = '资源发放模板'
        this.selectType = '0'
      } else {
        this.selectUrl = importURL.ImportingRecycledURL
        this.selectURLName = '资源回收模板'
        this.selectType = '1'
      }
    },
    async successEvent (msg) { // 上传成功文件回调
      this.importLoading = true
      this.msg = msg
      if (this.selectType === '0') {
        await importReleaseRecord({
          fileUrl: msg[0].url,
          check: true
        }).then((data) => {
          this.importLoading = false
          this.dataSource = data.errorMessageVOS
          this.isStandard = false
          if (!data.preHandleRes) {
            // this.dataSource = data.errorMessageVOS
            // this.isStandard = false
          } else {
            // this.dataSource = data.errorMessageVOS
            // this.isStandard = false
            this.columns = [
              {
                title: '行数',
                dataIndex: 'row',
                key: 'row'
              },
              {
                title: '超发信息',
                dataIndex: 'message',
                key: 'message'
              }]
            if (data.over) {
              this.popVisible = true
            } else {
              this.confirmImport()
            }
          }
        })
      } else {
        importRecoveryRecord({
          fileUrl: msg[0].url
        }).then((data) => {
          this.importLoading = false
          if (data.length > 0) {
            this.dataSource = data
            this.isStandard = false
          }
        })

        this.confirmImport()
      }
      this.uploadedName = msg[0].key
      this.uploadedURL = msg[0].url
      this.hasUploaded = true
    },
    uploadChange (value) {
      this.isStandard = true
      if (!value) {
        this.importLoading = false
      }
    },
    confirmImport () {
      this.popVisible = false
      if (this.selectType === '0') {
        importReleaseRecord({
          fileUrl: this.msg[0].url,
          check: false
        }).then(() => {
        })
      }

      const timer = setInterval(async () => {
        this.lopMessageVisible = true
        this.loopResult(timer)
      }, 1000)
      // this.lopMessage = res.progress
    },
    loopResult (timer) {
      // ajax请求
      if (this.selectType === '0') {
        importReleaseRecordProgress().then((data) => {
          if (data.res || !data.isHandle || !timer) {
            clearInterval(timer)
            if (data.res) {
              this.$emit('importOk')
              this.handleCancel()
            }
          }
          this.lopMessage = data.progress
        })
      } else {
        importRecoveryRecordProgress().then((data) => {
          if (data.res || !data.isHandle || !timer) {
            clearInterval(timer)
            if (data.res) {
              this.$emit('importOk')
              this.handleCancel()
            }
          }
          this.lopMessage = data.progress
        })
      }
    },
    confirmImportCancel () {
      this.popVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.a-import {
  /deep/.ant-row {
    margin: 20px;
  }
}

// /deep/ .ant-popover-placement-top{
//     left: 1039px;
//   }
</style>
